import Box from "@mui/material/Box";
import Grid from "components/primitives/Grid";
import RagMonitoringTemplateSelectorMenu from "components/RagMonitoringTemplateSelectorMenu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MonitoringSelectorButton } from "./AthleteTableHeader.components";
import MonitoringLabelsRow from "components/Monitoring/MonitoringLabelsRow";
import { useMultiSelectAll } from "providers/MultiSelectProvider";
import useAthleteStore from "providers/AthletesProvider/useAthleteStore";
import Tables from "components/Tables";
import { tableCells } from "../AthleteTable.config";
import { useTranslation } from "react-i18next";

interface AthleteTableHeaderProps {}

function AthleteTableHeader(props: AthleteTableHeaderProps) {
  const athletes = useAthleteStore();
  const selectAll = useMultiSelectAll(athletes);
  const { t } = useTranslation();

  return (
    <>
      <Grid {...Tables.headerContainerProps}>
        <Grid {...tableCells.groupColorBlocks} />
        <Grid {...tableCells.checkbox}>
          <Tables.Components.MultiSelectCheckbox
            slotProps={{
              input: { "aria-label": t("export.select_all_athletes_button_text") },
            }}
            checked={selectAll.value}
            indeterminate={selectAll.indeterminate}
            onChange={selectAll.toggle}
          />
        </Grid>
        <Grid {...tableCells.name} color="#FFF">
          <RagMonitoringTemplateSelectorMenu id="athlete-hub-rag-template-selector">
            {({ open, anchorProps, currentTemplate }) => (
              <MonitoringSelectorButton
                {...anchorProps}
                variant="text"
                size="small"
                color="inherit"
                endIcon={
                  <ExpandMoreIcon
                    color="inherit"
                    fontSize="large"
                    sx={{
                      transform: !open ? "rotate(0deg)" : "rotate(-180deg)",
                      transition: "transform 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                    }}
                  />
                }
              >
                <Box component="span" sx={{ fontSize: "h4.fontSize", fontWeight: "fontWeightMedium" }}>
                  {currentTemplate?.name || t("global.athlete_monitoring_label")}
                </Box>
              </MonitoringSelectorButton>
            )}
          </RagMonitoringTemplateSelectorMenu>
        </Grid>
        <Grid {...tableCells.monitoringIndicators} color="#FFF">
          <Box sx={{ height: "100%", py: 0 }}>
            <MonitoringLabelsRow />
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default AthleteTableHeader;
